import { gql } from '@apollo/client'

export default gql`
  mutation ReallocateShiftMutation($filters: ReallocateShiftFilters!) {
    reallocateShift(filters: $filters) {
      orphan_appointments
    }
  }
`
